import { XIcon } from '@phosphor-icons/react';
import * as Dialog from '@radix-ui/react-dialog';
import { IconButton } from '@/ui/button/Button';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  maxWidth?: string;
  onOpenAutoFocus?: (e: Event) => void;
}

export function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  maxWidth = 'max-w-lg',
  onOpenAutoFocus,
}: ModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm animate-fade-in" />
        <Dialog.Content
          className={`fixed left-1/2 top-1/2 z-50 w-full ${maxWidth} -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-line bg-surface-2 shadow-2xl flex flex-col animate-fade-in`}
          onOpenAutoFocus={onOpenAutoFocus}
          onPointerDownOutside={() => onClose()}
        >
          {/* `items-start` + a gap, not `items-center` with none: a description long enough to
              wrap otherwise runs under the close button and the X drifts to the block's middle. */}
          <div className="flex items-start justify-between gap-4 px-6 pt-6 pb-4">
            <div className="flex flex-col gap-1">
              <Dialog.Title className="text-[17px] font-semibold text-fg tracking-tight m-0">{title}</Dialog.Title>
              {description && (
                <Dialog.Description className="text-xs text-fg-tertiary m-0">{description}</Dialog.Description>
              )}
            </div>
            <Dialog.Close asChild>
              <IconButton>
                <XIcon size={16} />
              </IconButton>
            </Dialog.Close>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
